import { HouseOutlined } from "@mui/icons-material";
import { green } from "@mui/material/colors";
import { isEmpty, isNil } from "lodash";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CommentAttachmentChip from "../shared/CommentAttachmentChip";

// Property Preview Items
const RenderedPreviewPropertyItems = ({ loan, ids, onDelete }) => {
  const navigate = useNavigate();
  const getPropertyNameById = useCallback((loan, id) => {
    const property = loan?.subjectProperties?.find((b) => b._id === id);

    if (isNil(property)) {
      return "Unknown";
    }
    return property?.address?.fullAddress;
  }, []);

  const handleOnClick = useCallback(
    (id) => {
      navigate(`/loan/${loan?.loanNumber}/properties/${id}`);
    },
    [loan?.loanNumber, navigate]
  );

  if (isEmpty(ids)) {
    return null;
  }
  return ids.map((id) => (
    <CommentAttachmentChip
      key={id}
      attachmentId={id}
      background={green[50]}
      color={green[800]}
      icon={<HouseOutlined className="thin" />}
      onClick={() => handleOnClick(id)}
      onDelete={onDelete}
    >
      {getPropertyNameById(loan, id)}
    </CommentAttachmentChip>
  ));
};
export default RenderedPreviewPropertyItems;
